import React from "react";
import { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Row,
  Label,
  Col,
  Input,
  FormGroup,
  Form,
  Table,
  Button,
  Badge,
} from "reactstrap";
import style from "./style.module.scss";

const value = {
  date: "",
  type: "",
  id: 0,
  name: "",
  splitfrom: 0,
  splitto: 0,
  couponnumber: 0,
  corpEvent: 0,
};

const Errors = ({ toggle, bookerror, label, ...props }) => {
  const [modalerror, setmodalerror] = useState({ open: bookerror.open, desc: bookerror.desc });

  const toggleModal = () => {
    const value = false;
    setmodalerror((modalerror) => ({
      ...modalerror,
      open: value,
      desc: " ",
    }));
  };

  useEffect(() => {
    setmodalerror((modalerror) => ({
      ...modalerror,
      open: bookerror.open,
      desc: bookerror.desc,
    }));
  }, [bookerror]);

  return (
    <Modal isOpen={modalerror.open} toggle={toggle} className={style.taxing}>
      <ModalHeader toggle={toggle}>{label}</ModalHeader>
      <ModalBody className={style.body}>
        <FormGroup>
          <Label for="date">{label}</Label>
          <div></div>
          <Label for="type"> {modalerror.desc}</Label>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button onClick={() => toggleModal()} color="primary">
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default Errors;
